function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.294 0C7.95 0 9.447.67 10.53 1.755L12.285 0v5.25H7.035L9.45 2.835A4.434 4.434 0 006.29 1.5a4.492 4.492 0 00-4.232 3h-.014c-.085.241-.15.492-.194.75H.342A5.99 5.99 0 016.286 0h.008zM.296 6.75V12l1.754-1.755A5.966 5.966 0 006.286 12h.008a5.99 5.99 0 005.944-5.25H10.73a4.467 4.467 0 01-.194.75h-.013a4.492 4.492 0 01-4.232 3A4.434 4.434 0 013.13 9.165L5.544 6.75H.296z",
  fill: "#08F"
});

function SvgSyncIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSyncIcon;